import { Component, Input } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { LottieComponent } from "ngx-lottie";
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { FuseAlertComponent } from '@fuse/components/alert';
import { MatButtonModule } from '@angular/material/button';
import { LollyBooking } from 'app/models/bookings.model';

@Component({
  selector: 'app-reschedule-success',
  standalone: true,
  imports: [CommonModule,LottieComponent,FormsModule,MatIcon,MatButtonModule],
  templateUrl: './reschedule-success.component.html',
  styleUrl: './reschedule-success.component.scss'
})
export class RescheduleSuccessComponent {

  @Input() bookingdata : LollyBooking = new LollyBooking();
  @Input() bookingSlotTime : string = null;

  @Input() id: string = '';

  lottieConfig: Object;
  anim: any;

  constructor(){

    this.lottieConfig = {
      path: "../../../../assets/images/lottie/success_mark.json",
      renderer: "svg",
      autoplay: true,
      loop: false,
    
    };
  }

  ngOnInit(){
    console.log(this.bookingdata)
  }

  handleAnimation(anim: any) {
    this.anim = anim;
  }

  loadBookingPage(){
    window.location.href=`/bookings/${this.bookingdata.account_session_uuid}`
  }

}
